var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaldininiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 30
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path12",
    d: "M50.9 7v12.9h15.6V22H50V7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path14",
    d: "M22.6 14.2c2 .6 3.3 2 3.3 3.8 0 2.3-2 4-4.6 4H6.9v-7.3H0v-.8h6.9V7h13.8c2.6 0 4.6 1.6 4.6 3.8 0 1.5-1 2.7-2.7 3.4m-14.8-.3h12c2 0 3.2-1.1 3.2-3s-1.1-3.1-2.9-3.1H7.8zm13 7.3c1.7 0 2.9-1.3 2.9-3.2 0-2.5-1.7-3.4-3.2-3.4H7.8v6.6h13z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path16",
    d: "M93 7h.8v15H93z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path18",
    d: "M122.6 7h.8v15h-.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path20",
    d: "M152.2 7h.8v15h-.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path22",
    d: "M89.1 14.5c0 4.3-3.5 7.5-8 7.5H70V7h11.1c4.5 0 8 3.2 8 7.5zm-2.3 0c0-2-.6-3.7-1.6-4.9-1.1-1.2-2.6-1.8-4.4-1.8h-9.9v13.4h9.9c1.8 0 3.3-.6 4.4-1.8 1-1.2 1.6-2.9 1.6-4.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path24",
    d: "M46.9 22h-2.3l-2.5-4.3H31.5L28.7 22h-.8l9.5-15h.8zM37.1 8.6L32 16.9h9.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path26",
    d: "M117.7 22h-1.4L99.5 9.7V22h-.8V7h1.4l16.8 12.3V7h.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Baldinini-Logo_svg__path28",
    d: "M147.3 22h-1.4L129.1 9.7V22h-.8V7h1.4l16.8 12.3V7h.8z"
  })));
}
export default SvgBaldininiLogo;